import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import React from 'react';
import * as Sentry from '@sentry/react';

// Error: Multiple Sentry Session Replay instances are not supported
//
// Replay integration can be initialized only once.
// When user goes to service, then leaves it and comes back - the error occurs
// TODO: maybe there will be solution later
export const getReplayIntegration = () => {
  try {
    return Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    });
  } catch (err) {
    console.warn(err);
    return null;
  }
};

export const initSentry = () => {
  if (!process.env.REACT_APP_SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_VERSION,
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      ...[getReplayIntegration()].filter(Boolean),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [window.location.origin],
    // Capture Replay for 1% of all sessions,
    // plus for 10% of sessions with an error
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.1,
  });
};

export const SENTRY_MESSAGE_MARKER = {
  IMAGE_FAILED_TO_LOAD: 'image failed to load',
};

// INFO: simple cache to avoid duplicates
// can be solved with localStorage as an improvement if needed
const seen = {};
let availableEventsAmountToSend = 10;

export function captureAbsentImage(src) {
  if (!src || seen[src] || availableEventsAmountToSend <= 0) return;

  try {
    const error = new Error(
      `${SENTRY_MESSAGE_MARKER.IMAGE_FAILED_TO_LOAD}, src: ${src}`
    );
    // name should be unique for integration with slack
    error.name = `404 Image: ${src}`;

    Sentry?.captureException?.(error);
  } catch (err) {
    console.error('Error during capturing exception', err);
  }

  seen[src] = true;
  availableEventsAmountToSend--;
}
